import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createClient } from "../../api/apiClients";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لإنشاء عميل جديد
 */
export function useCreateClient() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createClientMutate,
        isPending,
    } = useMutation({
        mutationFn: createClient,
        onSuccess: (response) => {
            toast.success(response.message || "Created successfully");
            queryClient.invalidateQueries({ queryKey: ["clients"] });
            navigate('/clients');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create client");
        },
    });

    return {
        createClientMutate,
        isPending,
    };
}